import React from 'react'
import { NativeEvent } from '../../modules/types'
import './Select.css'

export type SelectOption = {
  key: string
  text: string
}

type Props = {
  error?: string | boolean
  options: SelectOption[]
  placeholder: string
  className?: string
  onChange?: (e: NativeEvent) => void
  [key: string]: any
}

function Select(props: Props) {
  const { error, options, placeholder, className, ...rest } = props

  const opt = options.map((option: SelectOption) => (
    <option key={option.key} value={option.key}>{option.text}</option>
  ))

  if (!error) {
    return (
      <select className={`select ${className}`} {...rest}>
        <option value=''>{placeholder}</option>
        {opt}
      </select>
    )
  } else {
    return (
      <select className={`select-error ${className}`} {...rest}>
        <option value=''>{placeholder}</option>
        {opt}
      </select>
    )
  }
}

export default Select
